var React = require('react');

function InviteIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","d":"M45.5 60c8 0 14.5-6.5 14.5-14.5S53.5 31 45.5 31 31 37.5 31 45.5c-.1 8 6.4 14.5 14.5 14.5zm1.9-21.8c0-1-.8-1.9-1.9-1.9s-1.9.8-1.9 1.9v5.4h-5.4c-1 0-1.9.8-1.9 1.9 0 1 .8 1.9 1.9 1.9h5.4v5.4c0 1 .8 1.9 1.9 1.9s1.9-.8 1.9-1.9v-5.4h5.4c1 0 1.9-.8 1.9-1.9 0-1-.8-1.9-1.9-1.9h-5.4v-5.4z","key":0}),React.createElement("path",{"d":"M1.9 46h-.3c-1-.1-1.8-1.1-1.6-2.1.7-5.1 3.2-9.8 7-13 4.6-3.9 10.6-5.4 16.4-4 1 .2 1.6 1.3 1.4 2.3s-1.3 1.6-2.3 1.4c-4.6-1.1-9.4.1-13.1 3.2-3.1 2.6-5.2 6.4-5.7 10.6-.1 1-.9 1.6-1.8 1.6zm18.5-21.1c-6.9 0-12.5-5.6-12.5-12.5S13.5 0 20.4 0s12.5 5.6 12.5 12.5-5.7 12.4-12.5 12.4zm0-21.1a8.71 8.71 0 0 0-8.7 8.7 8.71 8.71 0 0 0 8.7 8.7 8.71 8.71 0 0 0 8.7-8.7 8.71 8.71 0 0 0-8.7-8.7z","key":1})]);
}

InviteIcon.defaultProps = {"baseProfile":"tiny","viewBox":"0 0 60 60","overflow":"visible"};

module.exports = InviteIcon;

InviteIcon.default = InviteIcon;
